// extracted by mini-css-extract-plugin
export var settingsList = "_2v-0";
export var settingsRow = "_2v-1";
export var warningDot = "_2v-2";